module.exports = __webpack_public_path__ + "static/img/suv-grey.bbbd0eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-grey.svg
// module id = 9rvZ
// module chunks = 82